import {InputProps} from '../components/input';

export const getInput =
  <T>(data: Omit<InputProps<T>, 'type'>) =>
  (): InputProps<T> => ({
    ...data,
    type: 'input',
  });
